import {Component, Input, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'app-button',
  templateUrl: './stateful-button.component.html',
  styleUrls: ['./stateful-button.component.scss']
})
export class StatefulButtonComponent implements OnInit {
  @Input() classes: string;
  @Input() loading: boolean;
  @Input() size: 'xs'|'sm'|'md'|'lg'|'xl' = 'md';

  constructor() { }

  ngOnInit(): void {
  }

}
